import shortUUID from "short-uuid";
import { MessageTypes } from "../messageTypesEnum";
import { checkWatchVersion } from "../versionMismatch";
import { store } from "../../../redux/store";

export type WatchCheckTokenUsernameRequest = {
    id?: string;
    _id?: string;
    messageId: MessageTypes.CHECK_TOKEN_USERNAME;
    version: string;
    username?: string;
};

export async function checkTokenUsernameMessage(
    request: WatchCheckTokenUsernameRequest
) {
    await checkWatchVersion(request.version);

    const userId = store.getState().auth?.session?.user_id;

    let usernamesMatch: boolean;
    if (!userId) {
        usernamesMatch = true;
    } else if (!request.username) {
        usernamesMatch = true;
    } else {
        usernamesMatch = request.username === userId;
    }

    // WearOS correlates by echoing _id; iOS correlates by requestId.
    return {
        requestId: request.id,
        messageId: MessageTypes.CHECK_TOKEN_USERNAME_RESPONSE,
        _id: request._id || request.id || shortUUID().uuid(),
        usernamesMatch,
    };
}
